import { NgModule } from "@angular/core";
import { KycRouteComponent } from "@modules/kyc/components/kyc-route/kyc-route.component";
import { RouterModule } from "@angular/router";
import { AuthGuard } from "@main-services/auth-guard.service";

const components = [KycRouteComponent];

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path: "home/review-data",
				component: KycRouteComponent,
				canActivate: [AuthGuard]
			},
			{
				path: "home/review-data/edit",
				component: KycRouteComponent,
				canActivate: [AuthGuard]
			}
		])
	],
	declarations: [...components],
	exports: [...components]
})
export class KycRoutingModule {}
